"use client";
import styles from "./error-container.module.scss";
import Icon500 from "../../../../public/icon/icon-500.svg";
import Image from "next/image";

export default function ErrorContainer() {
  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorContent}>
        <div className={styles.contentBlock}>
          <Image src={Icon500} className={styles.iconError} width={500}></Image>
          <h1 className={styles.text}>Hệ thống xảy ra lỗi</h1>
        </div>
      </div>
    </div>
  );
}
